import React from 'react';
import { InterfaceContext } from 'src/contexts/interface';

export function useGetSidebarWidth() {
  const { sidebarOpened } = React.useContext(InterfaceContext);

  return sidebarOpened ? 256 : 77;
}
